/**
 * Mockup v3 P1 (Cuenta y seguridad): the strings of the `/cuenta` pages. Spread into `es` by
 * `es.ts`; P1 adds its keys here only, so no other phase edits this file. The copy is the v3
 * mockup's (`mockup-ux-redesign-v3.html`, section 6.10).
 */
export const esAccount = {
  "account.page.title": "Cuenta",
  "account.page.subtitle": "Tu perfil, la seguridad de tu cuenta y tus datos.",
  "account.tabs.label": "Secciones de la cuenta",
  "account.tabs.profile": "Perfil",
  "account.tabs.password": "Contraseña",
  "account.tabs.totp": "Verificación en dos pasos",
  "account.tabs.sessions": "Sesiones activas",
  "account.tabs.accessLog": "Registro de accesos",
  "account.tabs.data": "Mis datos",

  "account.profile.title": "Perfil",
  "account.profile.loadError": "No se pudo cargar tu perfil.",
  "account.profile.photoUpload": "Subir foto",
  "account.profile.photoChange": "Cambiar foto",
  "account.profile.photoInitials": "Usar mis iniciales",
  "account.profile.photoHelp": "PNG, JPEG o WebP, hasta 2 MB. Sin foto mostramos tus iniciales.",
  "account.profile.photoAlt": "Tu foto",
  "account.profile.initialsAlt": "Tus iniciales: {initials}",
  "account.profile.photoUpdated": "Foto actualizada",
  "account.profile.photoRemoved": "Ahora se muestran tus iniciales",
  "account.profile.photoTooLarge": "La foto pesa más de 2 MB.",
  "account.profile.photoRefused": "No se pudo usar esa imagen. Prueba con un PNG, JPEG o WebP de hasta 2 MB.",
  "account.profile.name": "Nombre completo",
  "account.profile.nameHelp": "Así te ven en los equipos, en las personas con acceso y en la auditoría.",
  "account.profile.nameRequired": "Escribe tu nombre.",
  "account.profile.nameTooLong": "El nombre puede tener hasta 120 caracteres.",
  "account.profile.email": "Correo electrónico",
  "account.profile.emailHelp": "Con este correo inicias sesión. Para cambiarlo, pídeselo a quien administra Valtx.",
  "account.profile.security": "Seguridad",
  "account.profile.totp": "Verificación en dos pasos",
  "account.profile.totpOnSince": "Activada desde {date}",
  "account.profile.totpOff": "Desactivada",
  "account.profile.manage": "Gestionar",
  "account.profile.memberSince": "En Valtx desde el {date}",
  "account.profile.save": "Guardar cambios",
  "account.profile.saved": "Nombre actualizado",

  "account.password.title": "Cambiar la contraseña",
  "account.password.current": "Contraseña actual",
  "account.password.new": "Contraseña nueva",
  "account.password.confirm": "Repite la contraseña nueva",
  "account.password.submit": "Cambiar la contraseña",
  "account.password.missing": "Rellena la contraseña actual y la nueva.",
  "account.password.mismatch": "Las contraseñas nuevas no coinciden.",
  "account.password.tooShort": "La contraseña debe tener al menos 12 caracteres.",
  "account.password.wrongCurrent": "La contraseña actual no es correcta. No se ha cambiado nada.",
  "account.password.done": "Contraseña actualizada hoy a las {time}.",
  "account.password.toast": "Contraseña actualizada",
  "account.password.strengthNone": "Escribe una contraseña",
  "account.password.strengthWeak": "Débil",
  "account.password.strengthFair": "Aceptable",
  "account.password.strengthGood": "Buena",
  "account.password.strengthStrong": "Muy buena",
  "account.password.strengthTooShort": "Demasiado corta",
  "account.password.strengthHelp": "{level}. Usa al menos {min} caracteres; mejor una frase larga que una palabra con símbolos.",

  "account.totp.title": "Verificación en dos pasos",
  "account.totp.loadError": "No se pudo comprobar tu verificación en dos pasos.",
  "account.totp.badgeOn": "Activada desde {date}",
  "account.totp.badgeOff": "Desactivada",
  "account.totp.badgeEnrolling": "Activando",
  "account.totp.intro":
    "Añade un segundo paso al iniciar sesión: además de tu contraseña, un código que cambia cada 30 segundos en tu móvil. Aunque alguien conozca tu contraseña, no podrá entrar.",
  "account.totp.activate": "Activar",
  "account.totp.onBody":
    "Al iniciar sesión te pediremos, además de la contraseña, el código de seis dígitos de tu aplicación de autenticación.",
  "account.totp.activatedAt": "Activada",
  "account.totp.app": "Aplicación",
  "account.totp.appValue": "La que escaneó el código QR",
  "account.totp.lastUsed": "Último uso",
  "account.totp.lastUsedToday": "Hoy, {time}",
  "account.totp.disable": "Desactivar",
  "account.totp.confirmPassword": "Para proteger tu cuenta, confirma primero tu contraseña.",
  "account.totp.passwordRequired": "Escribe tu contraseña actual.",
  "account.totp.continue": "Continuar",
  "account.totp.cancel": "Cancelar",
  "account.totp.cancelled": "No se activó la verificación en dos pasos",
  "account.totp.scan": "Escanea este código con tu aplicación de autenticación",
  "account.totp.scanHelp": "Google Authenticator, Microsoft Authenticator, 1Password u otra compatible.",
  "account.totp.qrLabel": "Código QR para tu aplicación de autenticación",
  "account.totp.secretLabel": "¿No puedes escanearlo? Escribe esta clave",
  "account.totp.copy": "Copiar",
  "account.totp.copied": "Clave copiada",
  "account.totp.copyFailed": "Selecciónala y copia con Ctrl+C",
  "account.totp.secretOnce": "Por seguridad esta clave solo se muestra ahora.",
  "account.totp.typeCode": "Escribe el código de seis dígitos que muestra la aplicación",
  "account.totp.codeGroup": "Código de seis dígitos",
  "account.totp.digit": "Dígito {n}",
  "account.totp.codeMissing": "Escribe los seis dígitos que muestra tu aplicación.",
  "account.totp.codeWrong": "El código no es correcto. Escribe el que muestra ahora tu aplicación.",
  "account.totp.verify": "Verificar y activar",
  "account.totp.activated": "Verificación en dos pasos activada",
  "account.totp.disableTitle": "¿Desactivar la verificación en dos pasos?",
  "account.totp.disableBody":
    "Tu cuenta quedará protegida solo por la contraseña. Para confirmar, escribe un código actual de tu aplicación.",
  "account.totp.disableCode": "Código de seis dígitos",
  "account.totp.disableDigits": "Escribe los seis dígitos.",
  "account.totp.disabled": "Verificación en dos pasos desactivada",

  "account.sessions.countOne": "1 sesión abierta. La ubicación es aproximada y sale de la IP.",
  "account.sessions.countMany": "{count} sesiones abiertas. La ubicación es aproximada y sale de la IP.",
  "account.sessions.revokeOthers": "Cerrar las demás sesiones",
  "account.sessions.noOthers": "No hay otras sesiones abiertas",
  "account.sessions.onlyThis": "Solo está abierta la sesión de este dispositivo.",
  "account.sessions.location": "Ubicación",
  "account.sessions.confirmTitle": "¿Cerrar las demás sesiones?",
  "account.sessions.confirmBodyOne": "Se cerrará 1 sesión en otros dispositivos. Esta sigue abierta.",
  "account.sessions.confirmBodyMany": "Se cerrarán {count} sesiones en otros dispositivos. Esta sigue abierta.",
  "account.sessions.confirm": "Cerrar las demás",
  "account.sessions.closedNone": "No había otras sesiones abiertas.",
  "account.sessions.closedOne": "Se cerró 1 sesión. Solo queda esta.",
  "account.sessions.closedMany": "Se cerraron {count} sesiones. Solo queda esta.",
  "account.location.unknown": "Ubicación desconocida",
  "account.geo.attribution": "Ubicación por IP de",

  "account.access.filterLabel": "Filtrar accesos",
  "account.access.all": "Todos",
  "account.access.bad": "Solo fallidos y bloqueados",
  "account.access.period": "Últimos 30 días",
  "account.access.title": "Registro de accesos",
  "account.access.loadError": "No se pudo cargar tu registro de accesos.",
  "account.access.date": "Fecha",
  "account.access.result": "Resultado",
  "account.access.origin": "Dispositivo, IP y ubicación",
  "account.access.reason": "Motivo",
  "account.access.success": "Correcto",
  "account.access.failure": "Fallido",
  "account.access.blocked": "Bloqueado",
  "account.access.unknownDevice": "Dispositivo desconocido",
  "account.access.unknownIp": "IP desconocida",
  "account.access.blockedNotice": "Hubo intentos bloqueados desde un dispositivo que no reconocemos.",
  "account.access.blockedStopped": "La verificación en dos pasos los detuvo.",
  "account.access.blockedIfNotYou": "Si no fuiste tú,",
  "account.access.blockedAnd": "y",
  "account.access.changePassword": "cambia tu contraseña",
  "account.access.enableTotp": "activa la verificación en dos pasos",
  "account.access.sentenceEnd": ".",
  "account.access.empty": "Todavía no hay accesos registrados",
  "account.access.emptyBody": "Cada vez que alguien intente entrar con tu cuenta lo verás aquí.",
  "account.access.emptyFiltered": "No hay accesos fallidos ni bloqueados",
  "account.access.emptyFilteredBody": "Todos los intentos de entrar con tu cuenta fueron correctos.",
  "account.access.more": "Cargar más",
  "account.access.moreFailed": "No se pudieron cargar más accesos. Vuelve a intentarlo.",
  // Owner 2026-10-19: "Dónde participas" on Perfil (v3 `acctProfile`).
  "account.participation.title": "Dónde participas",
  "account.participation.empty": "Todavía no participas en ninguna organización ni equipo.",
  "account.participation.unnamed": "Sin nombre",
  "account.reason.wrongPassword": "Contraseña incorrecta",
  "account.reason.accountInactive": "Cuenta desactivada",
  "account.reason.secondFactorMissing": "Faltó el código de verificación",
  "account.reason.secondFactorInvalid": "Código 2FA inválido",
  "account.reason.secondFactorReused": "Código 2FA ya usado",
  // Owner 2026-10-19 (migration `0039`): every organization of the person was suspended.
  "account.reason.organizationsSuspended": "Tus organizaciones estaban suspendidas",

  "account.data.exportTitle": "Descargar mis datos",
  "account.data.exportBody": "Un archivo JSON con tu perfil, dónde participas, tus sesiones y tu registro de accesos.",
  "account.data.exportFailed": "No se pudo preparar el archivo. Vuelve a intentarlo en unos minutos.",
  "account.data.download": "Descargar JSON",
  "account.data.downloading": "Descargando tus datos en JSON",
  "account.data.eraseTitle": "Borrar mi cuenta y mis datos personales",
  "account.data.eraseBody":
    "Se borran tus datos personales y se cierra tu sesión en todos los dispositivos. No se puede deshacer.",
  "account.data.eraseHelp":
    "Antes de borrar, pide a quien administra tu organización que reasigne tus mockups si alguien más los necesita.",
  "account.data.erase": "Borrar mi cuenta…",
  "account.data.eraseDialogTitle": "¿Borrar tu cuenta y tus datos personales?",
  "account.data.eraseWarning": "No se puede deshacer. Se cerrará tu sesión en todos los dispositivos.",
  // Owner 2026-10-19 (3B): the personal mockups leave with the account, the trash too; said before confirming.
  "account.data.erasePersonalMockups":
    "También se borrarán definitivamente tus mockups personales, incluidos los de la papelera, con sus mensajes y versiones. Sus enlaces compartidos dejarán de funcionar.",
  "account.data.eraseConfirmLabel": "Para confirmar, escribe tu correo: {email}",
  "account.data.eraseConfirm": "Borrar definitivamente",
  "account.data.eraseFailed": "No se pudieron borrar tus datos. Vuelve a intentarlo.",
  // The 409 `still_responsible`: only team and organization mockups refuse now (the personal ones leave with the
  // account, owner 2026-10-19, 3B), and only paths that really lower that count.
  "account.data.eraseStillResponsible":
    "Todavía eres responsable de mockups de un equipo o de la organización, también de los que están en la papelera. Tu cuenta no se puede borrar mientras sigan siendo tuyos.",
  "account.data.eraseStepShared":
    "Transfiérelos con «Transferir propiedad…» en su menú, o pide a quien administra tu organización que los reasigne.",
  "account.data.eraseStepTrash":
    "Los de la papelera también cuentan hasta que se eliminan solos al terminar su plazo, unos 30 días: restaura uno para transferirlo, o bórralo definitivamente desde la papelera si ya nadie lo necesita.",
  "account.data.erased": "Tu cuenta y tus datos personales se han borrado.",
} as const;
